import React, { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import UserJourneyBloc, {
  LearnPageViewConfig
} from "src/ui/components/UserJourneyOverview/UserJourneyBloc";
import UserJourneyOverview from "src/ui/components/UserJourneyOverview/UserJourneyOverview";
import ProgramDetails from "src/ui/components/ProgramDetails/ProgramDetails";
import Loader from "src/ui/components/Loader/Loader";

const PageWrapper = styled.div`
  padding: 0 var(--space-md);
`;

const LearnPage: FC = () => {
  const [loading, setLoading] = useState(true);
  const [viewConfig, setViewConfig] = useState<LearnPageViewConfig | null>(
    null
  );

  useEffect(() => {
    const initialize = async () => {
      const config = await UserJourneyBloc.loadAndDetermineViewType();
      setViewConfig(config);
      setLoading(false);
    };

    void initialize();
  }, []);

  if (loading || !viewConfig) {
    return <Loader fixed active />;
  }

  if (viewConfig.viewType === "cdcdpp") {
    return (
      <PageWrapper>
        <ProgramDetails program={KnownProgram.CDC_DPP} />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <UserJourneyOverview program={viewConfig.program} />
    </PageWrapper>
  );
};

export default LearnPage;
